export const environment = {
  production: true,
  supabaseUrl: 'https://supabase.api.polytan-infoarena.de',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5lY3l1a2dqZm9qaWNqdmtwb2xzIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY0Nzk4NjI4OSwiZXhwIjoxOTYzNTYyMjg5fQ.dWrlNKV32zfL7LJLISe8mPF7t-j3FAin8zMInK9mon4'
};
